//import { fetch } from 'domain-task';

/* new get method */
export async function get(url: string): Promise<any> {
    return sendRequest('GET', url);
}

export async function post(url: string, data: any): Promise<any> {
    return sendRequest('POST', url, data);
}

export async function put(url: string, data: any): Promise<any> {
    return sendRequest('PUT', url, data);
}

export async function remove(url: string, data: any = {}): Promise<any> {
    return sendRequest('DELETE', url, data);
}

export async function downloadFile(url: string, param?: any): Promise<any> {
    try {


        const response = await fetch(url, {
            method: param === undefined ? 'GET' : 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(param)
        });


        // TODO:  Need to handle 401 when bearer token is not valid from the server-side
        throwIfError(response);

        const blob = await response.blob();
        const disposition = response.headers.get('content-disposition') || '';
        const filename = disposition.split(';')[1].split('=')[1].replace(/^"(.*)"$/, '$1');

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(blobUrl);
        }

        return {};
    } catch (errors) {
        return Promise.reject(await getJson(errors));
    }
}

export function throwIfError(response: any): any {
    switch (response.status) {
        case 400:
        case 401:
        case 403:
        case 404:
        case 415:
        case 500:
            throw response;
        default:
            return response;
    }
}

async function sendRequest(method: string, url: string, data?: any): Promise<any> {
    try {

        let response;

        if (method === 'GET') {
            response = await fetch(url, {
                method: 'GET',
                headers: getHeaders()
            });
        } else {
            response = await fetch(url, {
                body: JSON.stringify(data),
                cache: 'no-cache',
                method,
                headers: getHeaders()

            });
        }

        if (response.status === 401) {
            return Promise.reject({
                '': [`Authentication failed.  Access denied to endpoint '${url}'`],
                responseStatusCode: response.status
            });
        }

        if (response.status === 403) {
            return Promise.reject({
                '': [`Authorization failed.  You do not have the neccessary permissions to perform this action`],
                responseStatusCode: response.status
            });
        }

        if (response.status === 404) {
            const body = await getJson(response);
            return Promise.reject({
                '': [body],
                responseStatusCode: response.status
            });
        }

        throwIfError(response);

        return Promise.resolve(await getJson(response));
    } catch (errors) {
        return Promise.reject(await getJson(errors));
    }
}

export async function getJson(response: any) {
    try {

        const body = await response.json();

        if (typeof body === 'string') {
            return {
                '': body,
                responseStatusCode: response.status
            };
        }

        body.responseStatusCode = response.status;
        return body;

    } catch (err) {
        console.log(err);
        return '';
    }
}

export function getHeaders() {
    return {
        'content-type': 'application/json',
        'Accept': 'application/json'
    };
}
